import type { TProjectGateProps } from './Projects.types.ts';
import { useProjects } from './use-projects/index.ts';

export const ProjectGate = ({
  loading,
  failed,
  none,
  unselected,
  children,
}: TProjectGateProps) => {
  const {
    projects,
    isLoadingProjects,
    projectsError,
    currentProjectId,
    settings,
  } = useProjects();

  if (isLoadingProjects) {
    return loading;
  }

  if (projectsError) {
    return failed;
  }

  if (projects.length === 0) {
    return none;
  }

  if (currentProjectId === undefined) {
    return unselected;
  }

  if (!settings) {
    return loading;
  }

  return children;
};
